<template>
  <div class="main">
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/middle/banner.jpg"
    ></landingBanner>
    <div class="content">
      <indexTitle title1="填写联系电话获取学费报价" title2="To get the tuition" color="#f8675c"></indexTitle>
      <footerForm color="#fff" bag="#f8675c" words="获取学费"></footerForm>
      <div style="width:100%;height:20px;"></div>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/middle/part1.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div class="button">
        <van-button color="#f8675c" style="width:100%" to="chat">在线了解详情</van-button>
      </div>
      <div style="width:100%;height:40px;"></div>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/middle/part2.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div class="button">
        <van-button color="#f8675c" style="width:100%" to="chat">在线了解详情</van-button>
      </div>
      <div style="width:100%;height:40px;"></div>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/middle/part3.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div style="width:100%;height:20px;"></div>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/middle/part4.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div class="button">
        <van-button color="#f8675c" style="width:100%" to="chat">咨询就业</van-button>
      </div>
      <div style="width:100%;height:40px;"></div>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/middle/part5.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div class="button"> 
        <van-button color="#f8675c" style="width:100%" to="chat">咨询老师</van-button>
      </div>
      <div style="width:100%;height:40px;"></div>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/middle/part6.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div style="width:100%;height:40px;"></div>
      <indexTitle title1="填写联系电话获取学费报价" title2="To get the tuition" color="#f8675c"></indexTitle>
      <footerForm color="#fff" bag="#f8675c" words="点击获取学费报价"></footerForm>
    </div>
    <div class="h25px" style="width:100%;height:25px;"></div>
    <foot></foot>
  </div>
</template>

<script>
export default {
  components: {
    landingBanner: () => import("../../../components/common/landing-banner"),
    foot: () => import("@/components/foot/foot"),
    find2: () => import("@/components/common/find2"),
    indexTitle: () => import("@/components/common/indexTitle"),
    footerForm: () => import("@/components/form/footerForm")
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
.content {
  width: 100%;
  padding: 10px;
  background: #fff;
}
</style>